import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../constants';
export const Definition = {
  // Works for both the minimized and expanded state including transitions between
  // the two without tracking a duplicate event.
  selector: `.page.csat`,
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    const titleElement = element.querySelector(`.heading, .thank-you-content`);
    const title = isHTMLElement(titleElement) ? getTranslationOrInnerText(titleElement) : 'no-title';
    return {
      type: NudgeTypes.POPUP_CSAT,
      title
    };
  }
};